var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 63 64.5",
    enableBackground: "new 0 0 63 64.5",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#16a085",
    d: "M57.2,2.6c-1.5,0-3.3,0.2-5.6,0.5c-2.3,0.4-3.9,0.8-4.8,1.3c-1,0.5-2.4,1.8-4.4,3.9c-1.9,2-4.4,5.3-7.4,9.5 c-3,4.3-5.6,8.4-7.8,12.4c-2,3.5-4,7.4-6,11.5c-1.4-1.8-2.9-3.2-4.4-4.3c-1.9-1.3-3.8-2-5.5-2c-1.7,0-3.7,0.8-5.7,2.3 c-2.1,1.6-3.2,3.4-3.2,5.3c0,1.5,0.9,3.2,2.8,5.2c2.7,3,4.9,5.8,6.5,8.3c1.2,1.8,2,3,2.5,3.6c0.6,0.6,1.3,1.1,2.1,1.4 c0.8,0.3,2.2,0.4,4.1,0.4c2.7,0,4.5-0.3,5.6-0.9c1.1-0.6,1.9-1.4,2.5-2.5c0.5-1,1.4-2.9,2.6-5.9c3-7.5,7.1-15.4,12.2-23.4 c5.1-8,10-14.2,14.7-18.6c1.2-1,1.9-1.8,2.2-2.3C60.8,7.9,61,7.2,61,6.4c0-1-0.4-1.9-1.1-2.6C59.3,3,58.3,2.6,57.2,2.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.a5a6ae88d580e3098b5305d8e2c6a539.svg";
export { ForwardRef as ReactComponent };